import React, { useState, useEffect } from "react"
import { Section, Box, Text, Link } from "@quarkly/widgets"
import { Override } from "@quarkly/components"
import * as Components from "components"
import translations from "../translations"

const Footer = ({ lang: controlledLang, ...props }) => {
  const [localLang, setLocalLang] = useState("en")

  useEffect(() => {
    const savedLang = localStorage.getItem("lang")
    if (savedLang) {
      setLocalLang(savedLang)
    }
  }, [])

  const currentLang = controlledLang || localLang

  useEffect(() => {
    const syncLang = () => {
      const savedLang = localStorage.getItem("lang")
      if (savedLang && savedLang !== localLang) {
        setLocalLang(savedLang)
      }
    }
    window.addEventListener("languagechange", syncLang)
    return () => window.removeEventListener("languagechange", syncLang)
  }, [localLang])

  const t = translations[currentLang]

  return (
    <Section
      padding="80px 60px 40px 60px"
      sm-padding="40px 20px 20px 20px"
      quarkly-title="Footer"
      background="--color-light"
      border-top="1px solid #EEEEEE"
      {...props}
    >
      <Override
        slot="SectionContent"
        max-width="1400px"
        flex-direction="column"
        grid-gap="60px"
      />
      <Box
        display="flex"
        flex-direction="row"
        justify-content="space-between"
        align-items="flex-start"
        sm-flex-direction="column"
        grid-gap="60px"
      >
        <Box
          display="flex"
          flex-direction="column"
          width="35%"
          sm-width="100%"
          color="--dark"
          grid-gap="16px"
        >
          <Components.Logo />
          <Text
            color="--darkL2"
            font="normal 300 15px/1.7 --fontFamily-googleInter"
            margin="0 0 0 0"
            max-width="320px"
          >
            {t.footer.desc}
          </Text>
        </Box>
        <Box display="flex" flex-direction="column" grid-gap="12px">
          <Text
            color="--darkL2"
            font="normal 600 11px/1.5 --fontFamily-googleInter"
            letter-spacing="3px"
            text-transform="uppercase"
            margin="0 0 8px 0"
          >
            {t.footer.navTitle}
          </Text>
          <Link
            href="/#approach"
            color="--grey"
            font="normal 300 15px/1.5 --fontFamily-googleInter"
            text-decoration-line="initial"
            hover-color="--dark"
          >
            {t.nav.approach}
          </Link>
          <Link
            href="/#services"
            color="--grey"
            font="normal 300 15px/1.5 --fontFamily-googleInter"
            text-decoration-line="initial"
            hover-color="--dark"
          >
            {t.nav.services}
          </Link>
          <Link
            href="/#team"
            color="--grey"
            font="normal 300 15px/1.5 --fontFamily-googleInter"
            text-decoration-line="initial"
            hover-color="--dark"
          >
            {t.nav.team}
          </Link>
          <Link
            href="/#contact"
            color="--grey"
            font="normal 300 15px/1.5 --fontFamily-googleInter"
            text-decoration-line="initial"
            hover-color="--dark"
          >
            {t.nav.contact}
          </Link>
          <Link
            href="/privacy-policy"
            color="--grey"
            font="normal 300 15px/1.5 --fontFamily-googleInter"
            text-decoration-line="initial"
            hover-color="--dark"
          >
            {t.footer.privacy}
          </Link>
          <Link
            href="/terms-and-conditions"
            color="--grey"
            font="normal 300 15px/1.5 --fontFamily-googleInter"
            text-decoration-line="initial"
            hover-color="--dark"
          >
            {t.footer.terms}
          </Link>
        </Box>
        <Box display="flex" flex-direction="column" grid-gap="12px">
          <Text
            color="--darkL2"
            font="normal 600 11px/1.5 --fontFamily-googleInter"
            letter-spacing="3px"
            text-transform="uppercase"
            margin="0 0 8px 0"
          >
            {t.footer.contactTitle}
          </Text>
          <Components.ProtectedEmail
            user="info"
            domain="myarchitecthelp.com"
            color="--grey"
            font="normal 300 15px/1.5 --fontFamily-googleInter"
            text-decoration-line="initial"
            hover-color="--dark"
          />
          <Text
            color="--grey"
            font="normal 300 15px/1.5 --fontFamily-googleInter"
            margin="0"
          >
            {t.footer.location}
          </Text>
        </Box>
      </Box>
      <Box
        border-top="1px solid #EEEEEE"
        padding="24px 0 0 0"
        display="flex"
        justify-content="space-between"
        align-items="flex-start"
        sm-align-items="center"
        sm-flex-direction="column"
        sm-grid-gap="12px"
      >
        <Box
          display="flex"
          flex-direction="column"
          grid-gap="4px"
          sm-align-items="center"
        >
          <Text
            color="--grey"
            font="normal 300 13px/1.5 --fontFamily-googleInter"
            margin="0"
          >
            {t.footer.copyright}
          </Text>
          <Text
            color="--grey"
            font="normal 300 13px/1.5 --fontFamily-googleInter"
            margin="0"
          >
            {t.footer.designedBy}{" "}
            <Link
              href="https://rewilt.com"
              target="_blank"
              color="--grey"
              hover-color="--dark"
              text-decoration-line="underline"
            >
              rewilt.com
            </Link>
          </Text>
        </Box>
        <Text
          color="--grey"
          font="normal 300 13px/1.5 --fontFamily-googleInter"
          margin="0"
          sm-text-align="center"
        >
          {t.footer.tagline}
        </Text>
      </Box>
    </Section>
  )
}

export default Footer
